module.exports = __webpack_public_path__ + "static/img/11.10a0a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/11.png
// module id = SNqh
// module chunks = 1